import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@/components/atoms/Button/Button';
import { dataLayerPush } from '@/helpers/dataLayer';
import { getAnchorNavIdFromTitle } from '@/utils/anchorNav';
import clsx from 'clsx';
import { useFocusManager } from 'react-aria';
const AnchorNavItem = ({ link, isActive, onClick, parentTitle }) => {
    const focusManager = useFocusManager();
    const handleOnKeyDown = (event) => {
        switch (event.key) {
            case 'ArrowRight':
                focusManager?.focusNext({ wrap: true });
                break;
            case 'ArrowLeft':
                focusManager?.focusPrevious({ wrap: true });
                break;
        }
    };
    const handleOnClick = (event) => {
        if (!link.text)
            return;
        event.preventDefault();
        dataLayerPush('serviceClick', {
            service_type: link.text,
            service: link.text,
            click_text: parentTitle,
        });
        onClick?.(link.text);
    };
    const anchorId = getAnchorNavIdFromTitle(link.text);
    return (_jsx("li", { onKeyDown: handleOnKeyDown, className: clsx(isActive ? 'hidden sm:flex' : 'flex'), children: _jsx(Button, { variant: "outline", children: (buttonProps) => (_jsx("a", { ...buttonProps, href: `#${anchorId}`, onClick: handleOnClick, className: clsx('grow sm:grow-0', isActive && '!border-border-contrast', buttonProps.className), "data-testid": `anchor-nav-link-${anchorId}`, role: "link", children: link.text })) }) }));
};
export default AnchorNavItem;
